import React, {ReactElement} from 'react';
import Sprite from 'styles/sprites/svg_sprite.svg';

import {svgSpriteInterface} from 'utils/svgSprite/svgSpriteInterface';

const SvgSpriteAsImage = ({sprite_name, alt}: svgSpriteInterface): ReactElement => <img
  src={`${Sprite}#${sprite_name}`}
  alt={alt}/>;
export default SvgSpriteAsImage;
